/*
 * 新規登録 登録元種別 定数
 */
/**
 * 登録元種別: 登録画面
 */
export const REGISTRATION_TYPE_NORMAL = 'REGISTRATION_NORMAL';
/**
 * 登録元種別: TOP（セミナー）
 */
export const REGISTRATION_TYPE_TOP_SEMINAR = 'REGISTRATION_TOP_SEMINAR';
/**
 * 登録元種別: コラム
 */
export const REGISTRATION_TYPE_COLUMN = 'REGISTRATION_COLUMN';
/**
 * 登録元種別: 資料
 */
export const REGISTRATION_TYPE_DOCUMENT = 'REGISTRATION_DOCUMENT';
/**
 * 登録元種別: コンサルサーチ
 */
export const REGISTRATION_TYPE_CONSULTANT_SEARCH = 'REGISTRATION_CONSULTANT_SEARCH';
/**
 * 登録元種別: コンサル詳細
 */
export const REGISTRATION_TYPE_PROFESSIONAL_ONE = 'REGISTRATION_PROFESSIONAL_ONE';
/**
 * 登録元種別: コーポレートページ
 */
export const REGISTRATION_TYPE_PROFESSIONAL_UNIT = 'REGISTRATION_PROFESSIONAL_UNIT';
/**
 * 登録元種別: セミナー
 */
export const REGISTRATION_TYPE_SEMINAR_LIST = 'REGISTRATION_SEMINAR_LIST';
/**
 * 登録元種別: 事例一覧
 */
export const REGISTRATION_TYPE_CASE_LIST = 'REGISTRATION_CASE_LIST';
/**
 * 登録元種別: 事例詳細
 */
export const REGISTRATION_TYPE_CASE_DETAIL = 'REGISTRATION_CASE_DETAIL';
